import { render, staticRenderFns } from "./NsHeaderMarketingMessage.vue?vue&type=template&id=45984602&scoped=true&"
import script from "./NsHeaderMarketingMessage.vue?vue&type=script&lang=js&"
export * from "./NsHeaderMarketingMessage.vue?vue&type=script&lang=js&"
import style0 from "./NsHeaderMarketingMessage.vue?vue&type=style&index=0&id=45984602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45984602",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/gitlab-runner-data/builds/ns-am/product/apps/catalog/components/Button.vue').default})
